import { gql } from '@apollo/client';

export * from './escrowMembers.query.generated';

export const ESCROW_MEMBERS = gql`
  query escrowMembers(
    $escrowPartyId: ID!
    $orderBy: EscrowMembersOrderByEnum
    $order: QueryOrderEnum
    $page: Int
    $perPage: Int
    $query: String
  ) {
    escrowMembers(
      escrowPartyId: $escrowPartyId
      orderBy: $orderBy
      order: $order
      page: $page
      perPage: $perPage
      query: $query
    ) {
      nodes {
        ...EscrowMemberFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
`;
